import ActiveProfileState from './state';

export const activeProfileInitialState: ActiveProfileState = {
  isArtist: true,
  id: undefined,
};
